import { convertDateToBE } from "@relode/core";
import { JobSalaryType } from "@relode/core/domain";
import { AddJobStep2Details } from "../../types/addJobStep2Details";
import { JobPendingStepTwoRequest } from "../controllers/jobs";

export const convertAddJobStep2DetailsRequest = (
    data: AddJobStep2Details
): JobPendingStepTwoRequest => {
    if (!data) return null;

    const step2: JobPendingStepTwoRequest = {
        jobName: data.jobName,
        teamId: data.teamId,
        locationId: data.location.locationId,
        normalizedJobName: data.normalizedJobName,
        normalizedLocationId: data.normalizedLocation.locationId,
        quantity: data.quantity,
        hoursPerWeek: data.hoursPerWeek,
        jobTypeId: data.jobTypeId,
        jobSalaryInUSDollars: data.jobSalaryInUSDollars,
        jobSalaryTypeId: data.jobSalaryTypeId ?? JobSalaryType.PerHour.id,
        contractStartDate: convertDateToBE(data.contractStartDate),
        contractDuration: data.contractDuration,
        contractDurationTypeId: data.contractDurationTypeId,
        jobConcurrencyToken: data.jobConcurrencyToken,
    };
    return step2;
};
